module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    class: {
      'mobile': _vm.$teras.device() === 'mobile'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "refdue",
    staticClass: "refdue",
    style: ({
      width: _vm.larghezza + 'px',
      display: 'none'
    })
  }), _vm._v(" "), (_vm.$teras.device() != 'mobile') ? _c('div', {
    staticClass: "fixed-side",
    style: ('margin-left:' + (_vm.larghezza - 200) + 'px'),
    attrs: {
      "id": "side"
    }
  }, [_c('site-side')], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.device() == 'mobile') ? _c('header-mobile') : _vm._e(), _vm._v(" "), (_vm.$teras.device() != 'mobile') ? _c('router-view', {
    style: ('padding:0 0 0 20px;width:' + (_vm.larghezza - 200) + 'px'),
    attrs: {
      "name": "main"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.device() == 'mobile') ? _c('router-view', {
    style: ('padding:0 10px 0 10px;'),
    attrs: {
      "name": "main"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fa2cf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 363
// module chunks = 0